import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: "Introduction",
      content: `
The terms “We / Us / Our / Company” refer to AICA HEALTH TECH Pvt Ltd and “You / Your / Yourself” refer to users.

This Privacy Policy is governed under the Information Technology Act, 2000. By using our platform, you agree to this policy.
      `,
    },
    {
      title: "User Information",
      content: `
We collect details such as name, email, age, gender, PIN code, medical records, biometric data, and payment information.
      `,
    },
    {
      title: "Cookies",
      content: `
We use cookies to improve user experience and analytics. Cookies do not access personal files.
      `,
    },
    {
      title: "Information Sharing",
      content: `
We do not sell personal data. Information is shared only when required by law or for security purposes.
      `,
    },
    {
      title: "Security",
      content: `
We use encryption and secure servers to protect your data, but no system is 100% secure.
      `,
    },
    {
      title: "Grievance Redressal",
      content: `
Users may contact our Grievance Officer for any issues regarding data or services.
      `,
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 relative overflow-hidden text-white">

      {/* Background glow */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-400/20 blur-3xl rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-emerald-400/20 blur-3xl rounded-full"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 py-10">

        {/* HEADER */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white/15 backdrop-blur-xl border border-white/20 mb-4">
            <ShieldCheck className="w-8 h-8 text-white" />
          </div>

          <h1 className="text-4xl sm:text-5xl font-bold text-white">
            Privacy Policy
          </h1>

          <p className="text-white/80 mt-2 text-sm sm:text-base">
            Last updated: August 2025
          </p>
        </div>

        {/* CONTENT */}
        <div className="space-y-6">

          {sections.map((sec, i) => (
            <div
              key={i}
              className="bg-white/10 border border-white/20 rounded-2xl p-6 shadow-lg backdrop-blur-md hover:bg-white/15 transition"
            >
              <h2 className="text-xl font-semibold mb-3 text-white">
                {sec.title}
              </h2>

              <p className="text-white/80 leading-relaxed whitespace-pre-line">
                {sec.content}
              </p>
            </div>
          ))}
        </div>

        {/* FOOTER */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/20 pt-6">

          <p className="text-white/70 text-sm text-center sm:text-left">
            © {new Date().getFullYear()} AICA HEALTH TECH Pvt Ltd
          </p>

          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-5 py-2 bg-white text-teal-700 font-semibold rounded-xl shadow hover:bg-gray-200 transition"
          >
            <ArrowLeft size={18} />
            Go Back
          </button>
        </div>

      </div>
    </div>
  );
};

export default PrivacyPolicy;